module.exports = __webpack_public_path__ + "static/media/25.ab69e8d9.png";